import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, Button, Toolbar, Typography } from "@mui/material";
import React from 'react';

export type TopbarProps = {
    title: string,
    logo?: React.ReactNode,
    color?: string,
    user?: {
        username: string,
        userLogo?: React.ReactNode,
        signOut?: (() => any) | null,
        userClick?: (() => any) | null
    }
}

export function Topbar({ title, color, logo, user }: TopbarProps) {
    let topbarColor = color ?? "#b00000";

    return (
        <Box sx={{ minHeight: 40, maxHeight: 40, background: topbarColor }}>
            <Toolbar
                sx={{
                    minHeight: 40,
                    maxHeight: 40,
                    display: 'flex',
                    justifyContent: "space-between",
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }}
                variant="dense"
            >
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    {logo ? logo : null}
                    <Typography
                        variant="body1"
                        sx={{
                            color: '#ffffff',
                            cursor: "pointer"
                        }}
                        component="span"
                    >
                        {title}
                    </Typography>
                </Box>

                {user ?
                    <Box display={'flex'}
                        alignItems='center'
                        justifyContent='end'
                    >
                        {user.userClick === null ?
                            null :

                            <Button onClick={(e) => {
                                console.log('User clicked')
                                if (user?.userClick) {
                                    user.userClick();
                                }
                            }}
                                sx={{ marginLeft: '20px', color: "#FFFFFF", textTransform: 'none' }}
                            >
                                {user.userLogo ? user.userLogo :

                                    <AccountCircleIcon sx={{ color: '#ffffff' }} />
                                }
                                <Typography
                                    sx={{ color: '#ffffff' }}>
                                    {user.username}
                                </Typography>
                            </Button>
                        }

                        {user.signOut === null ?
                            null
                            :
                            <Button onClick={(e) => {
                                console.log("Logout Clicked");
                                if (user.signOut) {
                                    user.signOut();
                                }
                                else {
                                    console.log("Warning - No signout method assigned");
                                }
                            }}
                                sx={{ marginLeft: '20px', color: "#FFFFFF", textTransform: 'none' }}
                            >
                                <Typography
                                    sx={{ color: '#ffffff' }}>
                                    Log ud
                                </Typography>
                            </Button>
                        }

                    </Box>
                    : null}
            </Toolbar>
        </Box>
    );
}

export default Topbar;